import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pre-survey',
  templateUrl: './pre-survey.component.html',
  styleUrl: './pre-survey.component.css'
})
export class PreSurveyComponent {

  isGetQuestionsLoading: boolean = false;

  constructor(
    private router: Router,
  ) {

  }

  iniziaClicked() {
    this.router.navigateByUrl('Survey');
  }

}
